export const INITIAL_FILTERS = {
  level: [],
  search: "",
  agency: "",
  mentor: "",
  status: "",
  payment_mode: "",
};

export const USER_DETAILS_INITIAL_STATE = {
  donorId: "", // donor_id
  fullName: "", // full_name
  initiatedName: "", // initiated_name
  phoneNumber: "", // mobile_number (mandatory)
  email: "", // email_id
  mentorId: "", // mentor_id
  mentorsName: "", // mentors_name
  gender: "", // gender
  processingAgency: "", // processing_agency
  city: "", // city
  donor_category: "voice", // donor_category (voice / campus preaching)
  country: "", // country
  state: "", // state
  zipCode: "", // zip_code
  totalDonation: "", // total_donation_amount (system calculated)
  dateOfBirth: "", // date_of_birth
  address: "", // residential_address
  permanentAddress: "", // permanent_address
  mode: "", // donation_mode
  donation_type: "", // donor_type (Regular / Occasional)
  startDate: "", // first_donation_date
  stopHoldDate: "", // last_donation_date
  panNo: "", // pan_number
  deductionDay: "", // deduction_day
  want80G: "", // want_80g_certificate (Yes/No)
};
